export default __webpack_public_path__ + "static/media/logo-flexge-color.a87f7dab.svg";